import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import * as Constants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import * as TaskManager from '../../../sagas/TaskManager';
import * as StoreUtils from '../../../store/StoreAccessor';
import Logger from '../../../tools/Logger';
import * as Utils from '../../../utils';

const log = Logger.child({ component: 'mediator/useCases/signUp' });

export const messages = defineMessages({
  registrationComplete: {
    id: 't.registrationComplete',
    defaultMessage: 'Your Pandora account has been created.  Enjoy the music!',
  },
});

export function getRegisterCompleteModalConfig() {
  const { dispatch } = StoreUtils.getStore();
  return {
    modalType: 'ModalCoachMark',
    title: '',
    body: <FormattedMessage {...messages.registrationComplete} />,
    onClose: () => {
      dispatch({
        type: Constants.ViewActions.CLOSE_MODAL,
      });
    },
    buttons: [],
  };
}

export function* registerListener({ payload }) {
  log.info('registerListener(): attempting to register listener');
  const { rememberMe: keepLoggedIn, ...params } = payload;

  yield call(
    TaskManager.putAndWait,
    getInDomain('listener.actions.register')({ ...params, keepLoggedIn }),
  );
}

export function* navigateToCommunity() {
  yield put(Actions.UseCases.navigateToCommunity());
}

export function* postRegistration() {
  log.info('postRegistration(): attempting post-registration work');
  const nextPath = yield select(Utils.Route.getNextPath, false);
  yield put(push(nextPath));

  const isMobileDevice = yield select(Utils.Capabilities.isMobileDevice);
  if (!isMobileDevice) {
    const modalConfig = yield call(getRegisterCompleteModalConfig);
    yield put(Actions.Modal.openModal(modalConfig));

    const hasExceededAnonListeningTime = yield select(Utils.Listener.hasExceededAnonListeningTime);
    if (hasExceededAnonListeningTime) {
      yield put(Actions.Playback.intentPlayTrack());
    }
  }
}
